const pagesExcludeFromPagination = ["about"]

module.exports = {
  pagesExcludeFromPagination,
}
